import(/* webpackMode: "eager", webpackExports: ["LoginClientPage"] */ "/opt/atlassian/pipelines/agent/build/apps/loyalty/app/[hostname]/(auth)/login/client.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/link.js");
